import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const BookmarkSolidIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg fill="none" height={size} viewBox="0 0 24 24" width={size}>
    <path
      d="M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L12 17.5L5 21V5Z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
